import { useCurrentRouteKey } from '#app/hooks/useCurrentRouteKey.js';
import { useLocation } from '#app/hooks/useLocation.js';
import { usePrevious } from '#app/hooks/usePrevious.js';
import { LastLocationContext } from './LastLocationContext.js';
import { type ReactNode, useMemo } from 'react';

type LastLocationProviderProps = {
  readonly children: ReactNode;
};

export const LastLocationProvider = ({
  children,
}: LastLocationProviderProps) => {
  const location = useLocation();
  const lastLocation = usePrevious(location);
  const routeKey = useCurrentRouteKey();
  const lastRouteKey = usePrevious(routeKey);

  const value = useMemo(() => {
    return lastLocation && lastRouteKey
      ? { ...lastLocation, routeKey: lastRouteKey }
      : null;
  }, [lastLocation, lastRouteKey]);

  return (
    <LastLocationContext.Provider value={value}>
      {children}
    </LastLocationContext.Provider>
  );
};
